import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import { AuthService } from '../api';

@Pipe({ name: 'TimeZoneConvert' })
export class TimeZoneConvertPipe implements PipeTransform {
  constructor(private authService: AuthService) { }

  zone_name: any;
  transform(val: any) {

    this.authService.user.subscribe(user => {

      this.zone_name = user.timezone.zone_name;
      // var timeval = JSON.parse(localStorage.getItem('userData'));

    });


    if (val != undefined) {
      return moment(val).tz(this.zone_name);

    }
    else {
      return '';
    }



  }
}


@Pipe({ name: 'TimeDateFormat' })
export class TimeDateFormatPipe implements PipeTransform {

  constructor(private authService: AuthService) { }


  country_code: any;

  transform(val: any) {

    this.authService.user.subscribe(user => {

      this.country_code = user.timezone.country_code;
      // var timeval = JSON.parse(localStorage.getItem('userData'));

    });


    var timeformat = "DD-MM-YYYY";

    switch (this.country_code) {

      case "IN": {
        timeformat = "DD-MM-YYYY";
        break;
      }
      case "US": {
        timeformat = "MM-DD-YYYY";
        break;
      }
      default: {
        timeformat = "DD-MM-YYYY";
      }
    }
    if (val != undefined) {
      return moment(val).format(timeformat);

    }
    else {
      return '';
    }
  }
}



@Pipe({ name: 'CustomDateFormat' })
export class CustomDateFormatPipe implements PipeTransform {

  constructor(private authService: AuthService) { }
  country_code: any;
  transform() {

    this.authService.user.subscribe(user => {

      this.country_code = user.timezone.country_code;
      // var timeval = JSON.parse(localStorage.getItem('userData'));

    });

    var timeformat = "DD-MM-YYYY";

    switch (this.country_code) {

      case "IN": {
        timeformat = "DD-MM-YYYY";
        break;
      }
      case "US": {
        timeformat = "MM-DD-YYYY";
        break;
      }
      default: {
        timeformat = "DD-MM-YYYY";
      }
    }

    return timeformat;
  }
}


@Pipe({ name: 'TimeFormat' })
export class TimeFormatPipe implements PipeTransform {

  country_code: any;
  constructor(private authService: AuthService) { }
  transform(val: any) {

    this.authService.user.subscribe(user => {

      this.country_code = user.timezone.country_code;
      // var timeval = JSON.parse(localStorage.getItem('userData'));

    });

    var minDate: Date = new Date();

    var tempDate = moment(minDate).format("YYYY-MM-DD");




    var timeformat = "h:mm A";

    switch (this.country_code) {

      case "IN": {
        timeformat = "h:mm A";
        break;
      }
      case "US": {
        timeformat = "h:mm A";
        break;
      }
      default: {
        timeformat = "h:mm A";
      }
    }
    if (val != undefined) {
      return moment(tempDate + ' ' + val).format(timeformat);

    }
    else {
      return '';
    }
  }
}




@Pipe({ name: 'FullTimeDateFormat' })
export class FullTimeDateFormatPipe implements PipeTransform {

  country_code: any;
  constructor(private authService: AuthService) { }
  transform(val: any) {

    this.authService.user.subscribe(user => {

      this.country_code = user.timezone.country_code;
      // var timeval = JSON.parse(localStorage.getItem('userData'));

    });

    var timeformat = "DD-MM-YYYY hh:mm A";

    switch (this.country_code) {

      case "IN": {
        timeformat = "DD-MM-YYYY hh:mm A";
        break;
      }
      case "US": {
        timeformat = "MM-DD-YYYY hh:mm A";
        break;
      }
      default: {
        timeformat = "DD-MM-YYYY hh:mm A";
      }
    }
    if (val != undefined) {
      return moment(val).format(timeformat);

    }
    else {
      return '';
    }
  }
}


